<template>
      <div class="view">
        <div class="artist cursor-pointer" v-on:click="changeView('artist')" :class="{'active':view === 'artist'}">ARTISTS</div>
        <div class="schedule cursor-pointer" v-on:click="changeView('schedule')" :class="{'active':view === 'schedule'}">SCHEDULE</div>
      </div>
</template>
<script>

export default {
  name: 'app',
  props: {
    view: String
  },
  components: {},
  methods: {
    changeView: function (newVal) {
      this.$emit('viewSelected', newVal)
    }
  }
}

</script>
